import React from 'react'
import SettingApiForm from '../components/setting/settingImageSizeForm'

const SettingIndex = () => {
    return (
        <>
            <SettingApiForm />
        </>
    )
}

export default SettingIndex